import React from 'react'
import { useObservableImmutable } from '@core/Utils/hooks/useObservableImmutable'
import { state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { state$ as navigationState$ } from '@core/State/Navigation/driver'
import { useLogon } from '@core/Utils/hooks/useLogon'
import {
  trackShareBetAcquisition,
  trackShareBetLogin,
} from '@core/Areas/ShareBet/helpers/analytics'

export const useShareBetAcquisitionTracking = () => {
  const { isLoggedIn } = useLogon()

  const { betSourceShareOrigin } = useObservableImmutable(quickbetState$, ['betSourceShareOrigin'])

  React.useEffect(() => {
    if (!betSourceShareOrigin || isLoggedIn) return

    let hasTracked = false

    const loginSubscription = userAccountState$
      .map(state => state.isLoggedIn)
      .pairwise()
      .distinctUntilChanged()
      .subscribe(([prevIsLoggedIn, newIsLoggedIn]) => {
        if (!prevIsLoggedIn && newIsLoggedIn && !hasTracked) {
          betSourceShareOrigin && trackShareBetLogin({ share_origin: betSourceShareOrigin })
          hasTracked = true
        }
      })

    const navSubscription = navigationState$.subscribe(navState => {
      const currentUrl = navState.get('currentUrl')
      if (currentUrl && currentUrl.toLowerCase().includes('signup')) {
        betSourceShareOrigin && trackShareBetAcquisition({ share_origin: betSourceShareOrigin })
        hasTracked = true
      }
    })

    return () => {
      loginSubscription.dispose()
      navSubscription.dispose()
    }
  }, [betSourceShareOrigin, isLoggedIn])
}
